
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.488 5.244l15.998 16.092-2.128 2.115L.361 7.36l2.127-2.115zm1.939 8.332l3.649 3.671H0v-3.67l4.427-.001zm17.032 0v3.671h-1.694v-3.67h1.694zm2.259 0v3.671h-1.695v-3.67h1.695zm-4.8 0v3.671h-2.382l-3.65-3.671h6.032zM14.318.812l.836.135-.021.17-.009.087c-.093 1.014-.009 2.169.384 3.25.467 1.285 1.31 2.266 2.623 2.849l.251.105c1.106.43 1.907.905 2.44 1.433.97.96 1.021 1.904.529 3.12l-.324.75-.793-.3.13-.307.144-.323.064-.15c.347-.864.331-1.446-.227-2.064l-.118-.124c-.442-.437-1.146-.855-2.152-1.246-1.696-.66-2.787-1.87-3.363-3.453-.442-1.218-.535-2.49-.431-3.618l.029-.26.008-.054zM15.925 0l.836.135-.021.17-.009.087c-.093 1.014-.009 2.169.384 3.25.496 1.366 1.418 2.387 2.874 2.953 1.104.43 1.904.904 2.437 1.43.973.961 1.025 1.907.532 3.124l-.324.75-.793-.3.185-.431.089-.2.064-.15c.348-.864.331-1.446-.229-2.065l-.119-.125c-.441-.436-1.145-.853-2.148-1.243-1.697-.66-2.788-1.87-3.364-3.453-.442-1.218-.535-2.49-.431-3.617l.029-.26.008-.055z","fill":"#fff"}})])
          )
        }
      }
    